import {Environment} from "../../environments/environment-model";
import {API_ENDPOINTS} from "../app.constants";
import {MediaInfoModel} from "../interfaces";

export const buildAssetManagementUrl = (environment: Environment): string => {
  return environment.apiGateway + API_ENDPOINTS.ASSET_MANAGEMENT + "/" + environment.apiVersion;
};

export const buildImageUrl = (
  image: MediaInfoModel,
  assetManagementUrl: string,
  authToken: string,
  width?: number,
  height?: number
) => {
  let result = "";
  if (image.url) {
    result = assetManagementUrl + image.url + `?access_token=${authToken}`;

    if (width) {
      result += `&width=${width}`;
    }
    if (height) {
      result += `&height=${height}`;
    }
  }
  return result;
};
